import Icon from "@mui/icons-material/Groups";
import { ProjectTakhmeenList } from "./ProjectTakhmeenList";
import { ProjectTakhmeenCreate } from "./ProjectTakhmeenCreate";
import { ProjectTakhmeenEdit } from "./ProjectTakhmeenEdit";
import { ProjectTakhmeenShow } from "./ProjectTakhmeenShow";

export default {
  list: ProjectTakhmeenList,
  create: ProjectTakhmeenCreate,
  edit: ProjectTakhmeenEdit,
  show: ProjectTakhmeenShow,
  icon: Icon,
  label: "Project takhmeen",
  options: { label: "Project takhmeen" },
  name: "projectTakhmeens",
};
